import { getServiceHistoryEndpoint } from './serviceHistoryEndpoint';
export async function fetchServiceHistoryPayload(payload) {
    const requestPayload = {
        limit: payload?.limit ?? 100,
        offset: payload?.offset ?? 0,
    };
    if (payload?.vin)
        requestPayload.vin = payload.vin;
    if (payload?.ffmCompanyId)
        requestPayload.ffmCompanyId = payload.ffmCompanyId;
    if (payload?.repairOrderId)
        requestPayload.repairOrderId = payload.repairOrderId;
    const response = await fetch(getServiceHistoryEndpoint(), {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestPayload),
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch service history: ${response.status}`);
    }
    const apiPayload = (await response.json());
    if (Array.isArray(apiPayload.errors) && apiPayload.errors.length > 0) {
        const firstError = apiPayload.errors[0]?.message || "Service history request failed";
        throw new Error(firstError);
    }
    return apiPayload;
}
